export interface EmojiOption {
  id: string;
  native: string;
  label: string;
}

export const EMOJI_OPTIONS: EmojiOption[] = [
  { id: '+1', native: '👍', label: 'Like' },
  { id: 'heart', native: '❤️', label: 'Love' },
  { id: 'clap', native: '👏', label: 'Clap' },
  { id: 'laughing', native: '😂', label: 'Haha' },
  { id: 'surprised', native: '😯', label: 'Surprised' },
  { id: 'thinking', native: '🤔', label: 'Thinking' },
];

const EmojiIcon = ({ symbol, size }: { symbol: string; size: number }) => (
  <div
    style={{
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <span style={{ fontSize: size, lineHeight: 1 }}>{symbol}</span>
  </div>
);

export default EmojiIcon;
